import { render, staticRenderFns } from "./B2C_CustomCourseForm.vue?vue&type=template&id=c1ff774e&scoped=true"
import script from "./B2C_CustomCourseForm.vue?vue&type=script&lang=js"
export * from "./B2C_CustomCourseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff774e",
  null
  
)

export default component.exports